import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams, IRowNode, SelectionChangedEvent } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { MultiSubscriptionComponent } from '@ddv/common-components';
import { CheckboxValue, EDITABLE_CHECKBOX_FIELD, QueryTypeName } from '@ddv/models';

import { TradeFileDetailsService } from '../../services/trade-file-details.service';

@Component({
    selector: 'app-checkbox-header',
    templateUrl: './checkbox-header.component.html',
    styleUrls: ['./checkbox-header.component.scss'],
    standalone: false,
})
export class CheckboxHeaderComponent extends MultiSubscriptionComponent implements IHeaderAngularComp {
    value: CheckboxValue;
    private params: IHeaderParams | undefined;
    private bindToggleHeaderCheckbox: ((event: SelectionChangedEvent) => void) | undefined;

    constructor(private readonly tradeFileDetailsService: TradeFileDetailsService) {
        super();
    }

    agInit(params: IHeaderParams): void {
        this.params = params;
        this.bindToggleHeaderCheckbox = this.toggleHeaderCheckbox.bind(this);
        this.toggleHeaderCheckbox();

        this.subscribeTo(this.tradeFileDetailsService.gridFilterChanged, (gridFilterChanged) => {
            if (gridFilterChanged) {
                this.toggleHeaderCheckbox();
            }
        });

        this.params.api.addEventListener('selectionChanged', this.bindToggleHeaderCheckbox);
    }

    refresh(): boolean {
        this.toggleHeaderCheckbox();
        return true;
    }

    destroy(): void {
        if (this.bindToggleHeaderCheckbox) {
            this.params?.api.removeEventListener('selectionChanged', this.bindToggleHeaderCheckbox);
        }
    }

    onClick(value: CheckboxValue): void {
        this.value = value;
        if (this.value) {
            this.params!.api.selectAllFiltered();
            this.params!.api.forEachNodeAfterFilter((node: IRowNode) => {
                if (node.data) {
                    node.data[EDITABLE_CHECKBOX_FIELD] = true;
                }
            });
        } else {
            this.params!.api.deselectAllFiltered();
            this.params!.api.forEachNodeAfterFilter((node: IRowNode) => {
                node.data[EDITABLE_CHECKBOX_FIELD] = false;
            });
        }
        this.params!.api.refreshCells({ force: true });
    }

    private toggleHeaderCheckbox(): void {
        const rows = { selected: 0, unselected: 0 };
        const queryType = this.params?.column.getColDef().cellRendererParams.queryTypeName;
        this.params!.api.forEachNodeAfterFilter((node: IRowNode) => {
            if (queryType !== QueryTypeName.SETTLEMENT_BREAKS) {
                this.countSelectedUnselectedNodes(node, rows);
            }

            if (node.selectable) {
                this.countSelectedUnselectedNodes(node, rows);
            }
        });

        this.value = rows.selected ?
            (rows.unselected ? undefined : true) :
            false;
        this.params!.api.refreshCells({ force: true });
    }

    private countSelectedUnselectedNodes(node: IRowNode, rows: { selected: number, unselected: number }): void {
        if (node.isSelected()) {
            rows.selected += 1;
        } else {
            rows.unselected += 1;
        }
    }
}
